
const caseManagementTimeOptions = [ // timeslot option list updated per SD #165147
  {
    label: '9:30-10:00',
    value: '09:30:00',
    duration: '30',
  },
  {
    label: '10:00-10:30',
    value: '10:00:00',
    duration: '30',
  },
  {
    label: '11:00-11:30',
    value: '11:00:00',
    duration: '30',
  },
  {
    label: '11:30-12:00',
    value: '11:30:00',
    duration: '30',
  },
  {
    label: '1:30-2:00',
    value: '13:30:00',
    duration: '30',
  },
  {
    label: '2:00-2:30',
    value: '14:00:00',
    duration: '30',
  },
  {
    label: '2:30-3:00',
    value: '14:30:00',
    duration: '30',
  },
];

export default caseManagementTimeOptions;